// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as JsBindings from "../../../../order-dashboard/view/library/JS/JsBindings.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function EditOrderFareDetailsSection(Props) {
  var crn = Props.crn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setOrderFare = match$1[1];
  var order_fare = match$1[0];
  React.useEffect((function () {
          EditOrderDataMachine.fetchOrderFareBreakup(crn, (function (data) {
                  return Curry._1(setOrderFare, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setOrderFare, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }), country);
          
        }), []);
  var getAmountWithSymbol = function (amount) {
    return Currency.toString(amount) + " " + CountryConfig.getSymbol(country);
  };
  if (typeof order_fare === "number") {
    return null;
  }
  switch (order_fare.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(LoadingViewComponent$Catalyst.make, {});
    case /* Live */1 :
        var data = order_fare._0;
        return React.createElement("div", undefined, React.createElement("div", {
                        className: "main-section"
                      }, React.createElement("div", {
                            className: "estimated-detail"
                          }, React.createElement("label", {
                                className: "name"
                              }, "Estimated Fare"), React.createElement("label", {
                                className: "value"
                              }, getAmountWithSymbol(data.estimated.trip_fare))), React.createElement("div", {
                            className: "estimated-detail"
                          }, React.createElement("label", {
                                className: "name"
                              }, "Estimated Distance"), React.createElement("label", {
                                className: "value"
                              }, String(data.estimated.travel_distance) + " KM")), React.createElement("div", {
                            className: "estimated-detail"
                          }, React.createElement("label", {
                                className: "name"
                              }, "Estimated Duration"), React.createElement("label", {
                                className: "value"
                              }, data.estimated.travel_duration.toFixed() + " mins"))), React.createElement("div", {
                        className: "detailed-fare-breakup"
                      }, React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Text */0,
                                  _0: "View more fare detail"
                                }, false, (function (_event) {
                                    return JsBindings.redirectNewTab(window.location.origin + ("/order_fare/" + crn));
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                          })));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: order_fare._0
                  });
    
  }
}

var make = EditOrderFareDetailsSection;

export {
  make ,
  
}
/* react Not a pure module */
